import React from 'react';
import HeaderMenu from '../../HeaderMenu';

import Img from '../../Img';
import { navigationIDs } from '../../Analytics/testIDConfig';
import { getClickAttrs } from '../../Analytics/gtag';

import styles from '../header.scss';

const DesktopPostButton = (props) => {
    const {
        plusButtonOptions,
        optionSelected,
        toggleHeaderMenu,
    } = props;
    return (
        <div className={`${styles.postWrapper}`}>
            <HeaderMenu
                options={plusButtonOptions}
                onOptionSelected={optionSelected}
                menuOpened={toggleHeaderMenu}
                menuClosed={toggleHeaderMenu}
                {...getClickAttrs({
                    category: 'Header post score Menu',
                    context: 'Header menu Button Click',
                    location: 'Header Nav Top',
                    testid: `${navigationIDs.postScore.component}-${navigationIDs.postScore.location}-${navigationIDs.postScore.id}`,
                })}
            >
                <div className={`${styles.post}`}>
                    <span className="sr-only">Post Score</span>
                    <Img src="/img/icons/plus.svg" />
                </div>
            </HeaderMenu>
        </div>
    );
};

export default DesktopPostButton;
